import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTrash, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import * as S from './styles';
import { NotaModalProps } from '../../../../pages/Cadastros/Notas/types';
import { Modal } from '../../../interface/Modal';
import Select2, { SelectOption } from '../../../Layout/Select2';

const NotaModal: React.FC<NotaModalProps> = ({
  isOpen,
  onClose,
  formData,
  entregadores,
  handleChange,
  handleSubmit,
}) => {
  if (!isOpen) return null;

  // Converter entregadores para o formato esperado pelo Select2
  const entregadoresOptions: SelectOption[] = [
    // Adicionar opção vazia para validação
    ...(formData.entregador ? [] : [{ value: '', label: 'Selecione um entregador' }]),
    ...entregadores.map((entregador) => ({
      value: entregador.codigousuario,
      label: entregador.nomeusuario,
    })),
  ];

  // Encontrar o entregador selecionado atualmente
  const selectedEntregador: SelectOption | null = formData.entregador
    ? entregadoresOptions.find((option) => option.value === formData.entregador) || null
    : null;

  // Função para lidar com a mudança no Select2
  const handleEntregadorChange = (option: SelectOption) => {
    const syntheticEvent = {
      target: {
        name: 'entregador',
        value: option.value,
      },
    } as React.ChangeEvent<HTMLSelectElement>;

    handleChange(syntheticEvent);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Nova Nota"
      headerIcon={faFileInvoiceDollar}
      size="large"
      >
      <S.Form onSubmit={handleSubmit}>
          <S.FormGroup>
            <S.Label htmlFor="chaveNota">
              Chave da Nota Fiscal / Código do Pedido*
            </S.Label>
            <S.Input
              id="chaveNota"
              name="chaveNota"
              value={formData.chaveNota}
              onChange={handleChange}
              maxLength={44}
              required
            />
            <S.HelpText>
              {formData.chaveNota && formData.chaveNota.length < 44
                ? 'Código do pedido identificado'
                : 'Chave da nota fiscal deve conter 44 caracteres'}
            </S.HelpText>
          </S.FormGroup>

          <S.FormGroup>
            <S.Label htmlFor="entregador-select">Entregador*</S.Label>
            <S.Select2Wrapper>
              <Select2
                id="entregador-select"
                name="entregador"
                options={entregadoresOptions}
                value={selectedEntregador}
                onChange={handleEntregadorChange}
                placeholder="Selecione um entregador"
                maxVisibleOptions={entregadoresOptions.length}
                className="required-select"
              />
            </S.Select2Wrapper>
            {/* Campo oculto para validação do formulário sem interagir com o layout */}
            {!formData.entregador && (
              <input
                type="hidden"
                name="entregador-validation"
                required
                onInvalid={(e) => {
                  e.preventDefault();
                  alert("Por favor, selecione um entregador");
                }}
              />
            )}
          </S.FormGroup>

          <S.ButtonContainer>
            <S.SaveButton type="submit">
              <FontAwesomeIcon icon={faSave} />
            </S.SaveButton>
            {formData.codigo && (
              <S.DeleteButton type="button" onClick={onClose}>
                <FontAwesomeIcon icon={faTrash} />
              </S.DeleteButton>
            )}
          </S.ButtonContainer>
        </S.Form>
      </Modal>
  );
};

export default NotaModal;
